module.exports = __webpack_public_path__ + "8f9e18374d736a6aca9159d3193f983a.png";